(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
function initializeHHProducts(scope) {
  scope.querySelectorAll('[data-hh-product-section]').forEach(function(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    var main = root.querySelector('#HHProductMainImage');
    var thumbs = root.querySelectorAll('.hh-thumb');
    if (main) {
      thumbs.forEach(function(button) {
        button.addEventListener('click', function() {
          main.removeAttribute('srcset');
          main.src = button.dataset.imageUrl;
          var fullImageLink = root.querySelector('.hh-full-image-link');
          if (fullImageLink) fullImageLink.href = button.dataset.fullImageUrl;
          var thumbImage = button.querySelector('img');
          if (thumbImage) main.alt = thumbImage.alt;
          if (button.dataset.imageWidth && button.dataset.imageHeight) {
            main.width = Number(button.dataset.imageWidth);
            main.height = Number(button.dataset.imageHeight);
          }
          thumbs.forEach(function(item) {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
        });
      });
    }
    var variantSelect = root.querySelector('select[name="id"]');
    var price = root.querySelector('.hh-price');
    var buyButton = root.querySelector('.hh-buy-button');
    if (!variantSelect || !price || !buyButton) return;
    function updateVariant(updateUrl) {
      var option = variantSelect.selectedOptions[0];
      if (!option) return;
      price.textContent = option.dataset.price;
      buyButton.textContent = option.dataset.buttonLabel;
      buyButton.disabled = option.dataset.available !== 'true';
      if (updateUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }
    variantSelect.addEventListener('change', function() { updateVariant(true); });
    updateVariant(false);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { initializeHHProducts(document); });
} else {
  initializeHHProducts(document);
}
document.addEventListener('shopify:section:load', function(event) { initializeHHProducts(event.target); });

  } catch(e) { console.error(e); }
})();
})();
